import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sera-recommended-force-meter',
    templateUrl: './sera-recommended-force-meter.component.html',
    styleUrl: './sera-recommended-force-meter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraRecommendedForceMeterComponent {
    @Input()
    greenLimit?: number;

    @Input()
    yellowLimit?: number;

    @Input()
    redLimit?: number;

    @Input()
    isTorque?: boolean;

    @Input()
    hintLabel!: string;

    readonly MAX_BAR_WIDTH = 98;
    readonly MIN_LIMIT_VALUE = 0.1;
    readonly MIN_DIFFERENCE = 15;
    readonly OFFSET_VALUE = 0.05;
    readonly RED_BADGE_POSITION = 95.5;
    readonly YELLOW_BADGE_MAX_POSITION = this.RED_BADGE_POSITION - this.MIN_DIFFERENCE;
    readonly GREEN_BADGE_MAX_POSITION = this.RED_BADGE_POSITION - 2 * this.MIN_DIFFERENCE;
}
